"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Key numbers used for ContentEditFeature
 */
var Keys;
(function (Keys) {
    Keys[Keys["NULL"] = 0] = "NULL";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["ENTER"] = 13] = "ENTER";
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["LEFT"] = 37] = "LEFT";
    Keys[Keys["UP"] = 38] = "UP";
    Keys[Keys["RIGHT"] = 39] = "RIGHT";
    Keys[Keys["DOWN"] = 40] = "DOWN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["EIGHT_ASTIRISK"] = 56] = "EIGHT_ASTIRISK";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["COMMA"] = 188] = "COMMA";
    Keys[Keys["DASH_UNDERSCORE"] = 189] = "DASH_UNDERSCORE";
    Keys[Keys["PERIOD"] = 190] = "PERIOD";
    Keys[Keys["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    Keys[Keys["GRAVE_TILDE"] = 192] = "GRAVE_TILDE";
    Keys[Keys["Ctrl"] = 256] = "Ctrl";
    Keys[Keys["Meta"] = 512] = "Meta";
    Keys[Keys["Shift"] = 1024] = "Shift";
    Keys[Keys["CONTENTCHANGED"] = 2048] = "CONTENTCHANGED";
    Keys[Keys["MOUSEDOWN"] = 4096] = "MOUSEDOWN";
})(Keys = exports.Keys || (exports.Keys = {}));
//# sourceMappingURL=ContentEditFeature.js.map